import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import type { Listing } from '../../types/housing';
import { priceMarkerLabel } from '../../utils/housingSignals';
interface HousingMapProps {
  listings: Listing[];
  campus: {
    lat: number;
    lng: number;
    name: string;
  };
  activeId: string | null;
  hoverId?: string | null;
  onSelect: (id: string) => void;
  className?: string;
}

/**
 * The map is a SUPPORTING surface. It carries price markers because price is
 * what makes a location meaningful to a student, and it stays synchronised
 * with the list in both directions: hovering or selecting a card highlights
 * its marker, and clicking a marker selects the card.
 */
function priceIcon(listing: Listing, active: boolean) {
  return L.divIcon({
    className: '',
    html: `<span class="cz-price-pin${active ? ' cz-price-pin-active' : ''}">${priceMarkerLabel(listing.rentPerYear)}</span>`,
    iconSize: [0, 0],
    iconAnchor: [0, 0]
  });
}
function campusIcon(name: string) {
  return L.divIcon({
    className: '',
    html: `<span class="cz-campus-pin">${name}</span>`,
    iconSize: [0, 0],
    iconAnchor: [0, 0]
  });
}
function FollowSelection({
  listings,
  activeId
}: {
  listings: Listing[];
  activeId: string | null;
}) {
  const map = useMap();
  useEffect(() => {
    if (!activeId) return;
    const listing = listings.find(entry => entry.id === activeId);
    if (listing) map.panTo([listing.lat, listing.lng], {
      animate: true
    });
  }, [activeId, listings, map]);
  return null;
}
export function HousingMap({
  listings,
  campus,
  activeId,
  hoverId,
  onSelect,
  className = ''
}: HousingMapProps) {
  return <MapContainer center={[campus.lat, campus.lng]} zoom={13} scrollWheelZoom className={`h-full w-full ${className}`} aria-label="Map of homes around your campus" data-id="element-1969" data-mp="2xgc0pc75wwub">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-1970" data-mp="36h0eq6wk2x77" />
      <Marker position={[campus.lat, campus.lng]} icon={campusIcon(campus.name)} data-id="element-1971" data-mp="2d3hj454udg2p" />
      {listings.map(listing => <Marker key={listing.id} position={[listing.lat, listing.lng]} icon={priceIcon(listing, listing.id === activeId || listing.id === hoverId)} eventHandlers={{
      click: () => onSelect(listing.id)
    }} alt={`${listing.name}, ₦${listing.rentPerYear.toLocaleString()} per year`} data-id="element-1972" data-mp="2hu7mjctpj8ur" />)}
      <FollowSelection listings={listings} activeId={activeId} data-id="element-1973" data-mp="2vrmhsy6n6aun" />
    </MapContainer>;
}